
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  NgZone,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { AbstractControl, FormsModule, ReactiveFormsModule, UntypedFormGroup } from "@angular/forms";
import { MatDatepickerInputEvent } from "@angular/material/datepicker";
import * as moment from "moment";
import { Subject } from "rxjs";
import { I18nService } from "../../i18n/service/i18n.service";
import { FormService } from "../../service/form-service/form.service";
import { IconModel } from "../icon/model/icon.model";
import { MobileComponent } from "../mobile/interface/mobile.component";
import { FilterModel } from "./model/filter.model";
import { COMMA, ENTER } from "@angular/cdk/keycodes";
// import { MapsAPILoader } from "@agm/core";
import { DateUtilService } from "../../service/date-util/date-util.service";
import { I18nPipe } from "../../i18n/pipe/i18n.pipe";
import { CommonModule } from "@angular/common";
import { MaterialModule } from "../../module/material.module";
import { IconComponent } from "../icon/icon.component";
import { BlockCopyPasteDirective } from "../../directives/block-copy-paste.directive";
import { MatSelectChange } from "@angular/material/select";

interface MultiselectOption {
  label: string;
  techname: string;
}

@Component({
  selector: "rfc-filter",
  templateUrl: "./filter.component.html",
  styleUrls: ["./filter.component.scss"],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    I18nPipe,
    CommonModule,
    MaterialModule,
    IconComponent,
    ReactiveFormsModule,
    FormsModule,
    BlockCopyPasteDirective,

  ]
})
export class FilterComponent extends MobileComponent implements OnChanges {
  @Input() filters: FilterModel;
  @Input() forceOpen: boolean = false;
  @Output() confirmEvent = new EventEmitter();
  @Output() discardEvent = new EventEmitter();

  filterList: any[];
  filterForm: UntypedFormGroup = new UntypedFormGroup({});
  formCreated: Subject<boolean> = new Subject();
  settedFilters: string;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  longitude: number;
  latitude: number;
  maxDate: Date;

  selectedOption: any;

  @ViewChild("search")
  public searchElementRef: ElementRef;

  constructor(
    private formService: FormService,
    private i18nService: I18nService,
    // private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    private dateUtil: DateUtilService,

  ) {
    super();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!!this.filters && this.filters.filterList?.length > 0) {
      //Disabilito date future ad oggi se startDateMax = true
      if (this.filters.maxDateRange) {
        this.maxDate = new Date();
      }
      //  else {
      //   const today = new Date;
      //   const maxDate = new Date(today.getFullYear(), today.getMonth() + 3, today.getDate());
      //   this.maxDate = maxDate;
      //   console.log('maxDate', this.maxDate)
      // }

      this.filterList = this.filters.filterList;
      this.filterForm = this.formService.toFormGroup(this.filterList);
      this.countSettedFilters();
      this.loadGoogleAutocomplete();
    }
  }

  getErrorMessage(techname): string {
    switch (techname) {
      case "contractPlateModel": {
        if (this.control(this.filterForm, techname).hasError("pattern")) {
          return this.i18nService.getTranslation("invalid_codePlate");
        }
      }
    }
  }

  changeValue(event, formField, mainFilter?) {
    const formName = mainFilter
      ? `${mainFilter.techname}.${formField.techname}`
      : `${formField.techname}`;

    if (typeof event == "string") {
      event = event.trim();
    }

    const value = formField.formatType == "text-array" ? [event] : event;
    this.filterForm.get(formName).setValue(value);
    this.countSettedFilters();
  }

  changeValueForToggle(event, formField,elemntTechname, mainFilter?) {
    const toggleName = mainFilter?
    `${mainFilter.techname}.${formField.techname}` :
     ` ${formField.techname}`;

    const formName = mainFilter ?
    `${mainFilter.techname}.${formField.techname}.${elemntTechname}`:
    `${formField.techname}.${elemntTechname}`;

    var toggleNameElement = this.filterForm.get(toggleName).value;
    for (let key in toggleNameElement) {
      if (toggleNameElement.hasOwnProperty(key)) {
        if(key==elemntTechname){
          toggleNameElement[key] = 'true';
        }
        toggleNameElement[key] = 'false';
      }
    }
    this.filterForm.get(toggleName).setValue(toggleNameElement);

    this.filterForm.get(formName).setValue(true);
    this.countSettedFilters();
  }

  private countSettedFilters(): void {
    const checkedValues = this.getNumOfSelectedValues(this.filterForm.value);
    this.settedFilters = checkedValues > 0 ? `(${checkedValues})` : "";
  }

  private isLocationSearchPresent(): boolean {
    for (const filter of this.filterList) {
      if (filter?.formatType === "location-search") {
        return true;
      }
    }
    return false;
  }

  private loadGoogleAutocomplete(): void {
    const isLocationSearchPresent = this.isLocationSearchPresent();

    if (!!isLocationSearchPresent) {
      // this.mapsAPILoader.load().then(() => {
      //   const autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement);
      //   autocomplete.addListener("place_changed", () => {
      //     this.ngZone.run(() => {
      //       const place: google.maps.places.PlaceResult = autocomplete.getPlace();

      //       if (place.geometry === undefined || place.geometry === null) {
      //         return;
      //       }
      //       this.latitude = place.geometry.location.lat();
      //       this.longitude = place.geometry.location.lng();
      //     });
      //   });
      // });
    }


  }

  private getNumOfSelectedValues(obj: object) {
    let sum = 0;
    for (const key in obj) {
      if (obj[key] instanceof Object) {
        sum += this.getNumOfSelectedValues(obj[key]);
      } else {
        if (!!obj[key] && obj[key] !== "false") {
          sum++;
        }
      }
    }
    return sum;
  }

  setIconAttributeForRendering(filter: FilterModel) {
    const iconInput = {
      isMatIcon: filter.isMatIcon,
      iconName: filter.iconName,
    } as IconModel;
    return iconInput;
  }

  checkIfExpanded(isMobile): boolean {
    return this.forceOpen ? true : !isMobile;
  }

  getButtonLabelDiscard() {
    return !!this.filters && !!this.filters.button_discard_label
      ? this.i18nService.getTranslation(this.filters.button_discard_label)
      : this.i18nService.getTranslation("reset");
  }

  getButtonLabelConfirm() {
    return !!this.filters && !!this.filters.button_confirm_label
      ? this.i18nService.getTranslation(this.filters.button_confirm_label)
      : this.i18nService.getTranslation("confirm");
  }

  discard() {
    this.filterForm.reset();
    this.countSettedFilters();
    const formToObject = this.convertFormToObject(this.filterForm.value);
    if (this.isLargeScreen) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
    this.discardEvent.emit(formToObject);
  }

  confirm(): void {
    const formToObject = this.convertFormToObject(this.filterForm.value);
    this.clearAutocompleteInput();
    if (this.isLocationSearchPresent()) {
      this.addMapsPositionToFilter(formToObject);
    }
    if (this.isLargeScreen) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
    this.confirmEvent.emit(formToObject);
  }

  private addMapsPositionToFilter(filter: any): void {
    filter.gpsPosition = {
      latitude: this.latitude,
      longitude: this.longitude
    };
  }


  clearAutocompleteInput(): void {
    const chipAutocompleteContainer = document.querySelectorAll(
      ".filters-container .mat-chip-list-wrapper"
    );
    chipAutocompleteContainer.forEach((element) => {
      const inputs = element.querySelectorAll("input");
      inputs.forEach((input) => (input.value = ""));
    });
  }

  isEmpty(val: any) {
    if (val === null || val === undefined || val === "") {
      return true;
    } else if (typeof val === "object") {
      if (Array.isArray(val)) {
        return val.length <= 0;
      } else {
        return Object.keys(val).length < 1;
      }
    } else {
      return false;
    }
  }

  // TODO Migliorare la gestione in caso di filtri innestati oltre il secondo livello
  // al momento l'unico caso è gestito puntalmente per le date
  private convertFormToObject(formObj: object) {
    const obj = {};
    for (const key in formObj) {
      const filterDefinition = this.filterList.find(filter => filter.techname == key);
      if (filterDefinition.formatType == "grouped_accordion") {
        const subObj = formObj[key];
        let tmpArray = [];
        Object.keys(subObj)
          .filter(keyVal => subObj[keyVal] === true)
          .forEach(stringConcatValues => {
            tmpArray = tmpArray.concat(stringConcatValues.split(","));
          });

        if (!this.isEmpty(tmpArray)) {
          obj[key] = tmpArray;
        }
      } else if(filterDefinition.formatType == "accordion" && filterDefinition.child?.length>0 && filterDefinition.child[0].formatType=='toggle_button_single' ) {
         for (let subtree in formObj[key]) {
            obj[key] = formObj[key][subtree];
          }

      } else if(filterDefinition.formatType == "text-array" ){
        //GESTIONE PER FILTRI DI TIPO TEXT-ARRAY(ARRAY DI STRINGHE)
        for (let subtree in formObj[key]) {
          obj[key] = [formObj[key][subtree]];
        }
      }
      else if (formObj[key] instanceof Object) {
        const subObj = formObj[key];
        if (subObj.date) {
          if (subObj.date instanceof Object) {
            Object.keys(subObj.date).forEach((key) => {
              if (this.isEmpty(subObj.date[key])) {
                delete subObj.date[key];
              }
            });
          }

          if (!this.isEmpty(subObj.date)) {
            obj[key] = subObj.date;
          }
        } else {
            const values = Object.keys(subObj).filter((keyFiltered): any => {
              if (!!subObj[keyFiltered] && subObj[keyFiltered] !== "false") {
                return subObj[keyFiltered];
              }
            });
            if (values.length > 0) {
              obj[key] = values;
            }
                
        }
      } else if (!this.isEmpty(formObj[key])) {
        obj[key] = formObj[key];
      }
    }
    return obj;
  }

  changeDate(
    event: MatDatepickerInputEvent<Date>,
    parentFormsId: string,
    techName: string
  ) {
    const date = moment(event.value).format("DD/MM/YYYY");
    this.filterForm.get(parentFormsId).get(techName).setValue(date);
  }


  changeDate2(
    event: MatDatepickerInputEvent<Date>,
    parentFormsId: string,
    techName: string
  ) {
    const date = moment(event.value).format("DD/MM/YYYY");
    if(techName === 'start') {
      const today = this.dateUtil.getDateObject(date, "DD/MM/YYYY");
      const maxDate = new Date(today.getFullYear(), today.getMonth() + 6, today.getDate());
      this.maxDate = maxDate;
    }
    this.filterForm.get(parentFormsId).get(techName).setValue(date);
  }

  monthDiff(d1, d2) {
    var months;
    months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth();
    months += d2.getMonth();
    return months <= 0 ? 0 : months;
  }

  changeSingleDate(event: MatDatepickerInputEvent<Date>, formFieldName: string) {
    const date = moment(event.value).format("DD/MM/YYYY");
    this.filterForm.get(formFieldName).setValue(date);
  }

  private getDateFromString(date: string) {
    if (date) {
      return moment(date, "DD/MM/YYYY").toDate();
    }
    return null;
  }

  getDateRangeTechName(type: string, filter) {
    const { techname } =
      filter.child.find((el) => el.formatType === type) || {};
    if (techname) {
      return techname;
    }
    console.error(
      `An error occured on getDateTechName. Check your date range configuration is missing for ${type}`
    );
  }

  getDateRangeValue(filter, filterForm: UntypedFormGroup, type: string, mainFilter) {
    if (filterForm) {
      return this.getDateFromString(
        filterForm
          .get(`${mainFilter.techname}.${filter.techname}`)
          .get(this.getDateRangeTechName(type, filter)).value
      );
    }
  }

  getFormControl(formField, mainFilter?): AbstractControl {
    const formName = mainFilter
      ? `${mainFilter.techname}.${formField.techname}`
      : `${formField.techname}`;

    return this.filterForm.get(formName);
  }

  // Multiselect
  getSelectedOptions(
    options: Array<MultiselectOption>,
    formField,
    mainFilter?
  ): Array<MultiselectOption> {
    const formControl = this.getFormControl(formField, mainFilter);

    return options.filter(
      (option) => formControl.value[option.techname] == true
    );
  }

  selected(event, formField, input: any): void {
    this.changeValue(true, { techname: event?.option?.value }, formField);
    input.value = "";
    console.log('selected value', this.selectedOption)
  }

  removeFromMultiSelectValue(event, formField): void {
    this.changeValue(false, { techname: event }, formField);
  }

  getFilteredOptions(
    options: Array<MultiselectOption>,
    filter: string
  ): Array<MultiselectOption> {
    const filterValue = filter.toLowerCase();

    return options.filter((option) =>
      option.label.toLowerCase().includes(filterValue)
    );
  }
  // End Multiselect

  onClose() { }

  selectedSingleOption(event: MatSelectChange, filter: any) {
    const selectedValue = event.value;
    const selectedOption = filter.child.find(option => option.techname === selectedValue);
    console.log('Selected option:', selectedOption);
    
  }
}
